import { HTTP_CP_ListSignInCompanies_Response_Company, HTTP_CP_SignIn_WithCode_Response } from '@api-new/authservice';
import { HTTP_CP_LoadSignInBranding_Response } from '@api-new/companyservice';
import { HTTP_CP_DoesEmailExist_Response } from '@api-new/userservice';
import { ErrorReasonEnum } from '@error/ENUM_ErrorReason';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';
import { PendingSignInModel } from '@shared/store/auth/models/pending-sign-in.model';

export const getListOfSignInCompanies = createAction('[AUTH] Get List Of Sign In Companies');

export const getListOfSignInCompaniesSuccess = createAction(
  '[AUTH] Get List Of Sign In Companies Success',
  props<{
    companies: HTTP_CP_ListSignInCompanies_Response_Company[];
  }>(),
);

export const getListOfSignInCompaniesFailure = createAction(
  '[AUTH] Get List Of Sign In Companies Failure',
  props<{
    error: ErrorModel;
  }>(),
);

export const loginSuccess = createAction(
  '[AUTH] Login Success',
  props<{
    signInResponse: HTTP_CP_SignIn_WithCode_Response;
    link?: string;
  }>(),
);

export const selectSignInCompany = createAction('[AUTH] Select Sign In Company', props<{ companyId: string }>());

export const setPendingSignIn = createAction('[AUTH] Set Pending Sign In', props<{ pendingSignIn: PendingSignInModel }>());

export const pendingSignInSuccess = createAction(
  '[AUTH] Pending Sign In Success',
  props<{
    signInResponse: HTTP_CP_SignIn_WithCode_Response;
  }>(),
);

export const loginFailure = createAction('[AUTH] Login error', props<{ error: ErrorModel }>());

export const setSignInLinkCompanies = createAction(
  '[AUTH] Set Sign In Link Companies',
  props<{
    email: string;
    code: string;
    signInCompanyId: string | null;
    redirectUrl: string | null;
    companies: HTTP_CP_ListSignInCompanies_Response_Company[];
  }>(),
);

export const checkManualLoginCode = createAction('[AUTH] Check Manual Login Code', props<{ verificationCode: string }>());

export const loginWithToken = createAction('[AUTH] Login With Token', props<{ token: string; redirectUrl?: string }>());
export const loginWithTokenSuccess = createAction(
  '[AUTH] Login With Token Success',
  props<{
    signInResponse: { accessToken: string };
  }>(),
);

export const logoutAndRedirect = createAction('[AUTH] Logout And Redirect');

export const resetStore = createAction('[AUTH] Reset Store');

export const authError = createAction('[AUTH] Auth Error', props<{ errorCode: ErrorReasonEnum }>());

export const getAuthPagesBranding = createAction('[AUTH] Get Auth Pages Branding', props<{ domain: string }>());

export const getAuthPagesBrandingSuccess = createAction(
  '[AUTH] Get Auth Pages Branding Success',
  props<{
    branding: HTTP_CP_LoadSignInBranding_Response;
  }>(),
);

export const getAuthPagesBrandingFailure = createAction('[AUTH] Get Auth Pages Branding Failure', props<{ error: ErrorModel }>());

export const sendVerificationCode = createAction('[AUTH] Send Verification Code Mail', props<{ email: string; isResend?: boolean }>());

export const sendVerificationCodeSuccess = createAction('[AUTH] Send Verification Code Mail success', props<{ isResend: boolean }>());

export const hideNewCodeSent = createAction('[AUTH] Hide New Code Sent');

export const newSignInEmailSent = createAction('[AUTH] New Sign In Email Sent', props<{ email: string; signInCompanyId: string | null }>());

export const sendVerificationCodeFailure = createAction('[AUTH] Send Verification Code Mail Failure', props<{ error: ErrorModel }>());

export const checkLoginMail = createAction('[AUTH] Check User Mail Before Login', props<{ email: string }>());

export const checkLoginMailSuccess = createAction('[AUTH] Check User Mail Before Login Success', props<HTTP_CP_DoesEmailExist_Response>());

export const checkLoginMailFailure = createAction('[AUTH] Check User Mail Before Login Failure', props<{ error: ErrorModel }>());

export const navigateToVerifyCodeAndSendEmail = createAction('[AUTH] Navigate To Verify Code And Send Email');

export const navigateToVerifyCode = createAction('[AUTH] Navigate To Verify Code');

export const setRedirectUrlAfterLoginAction = createAction('[AUTH] Set Redirect Link After Login', props<{ redirectUrl: string }>());
